import { Modal, Button, Spinner } from "reactstrap";

const crossIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
  >
    <path
      d="M31.0493 10.3472L10.3496 31.0416"
      stroke="#000000"
      strokeWidth="2"
    />
    <path
      d="M10.3501 10.3472L31.0498 31.0416"
      stroke="#000000"
      strokeWidth="2"
    />
  </svg>
);
const ReloadConfirmationModal = ({
  onConfirm,
  onCancel,
  isOpen,
  handleSubmit,
  loading,
}) => {
  return (
    <Modal isOpen={isOpen} contentClassName="reload-modal">
      <div
        onClick={onCancel}
        className="d-flex justify-content-end"
        style={{ cursor: "pointer" }}
      >
        {crossIcon}
      </div>
      <div className="d-flex justify-content-center mt-3">
        <div className="reload-text">
          Would you like to finish your campaign <b>later</b>?
        </div>
      </div>
      <div className="d-flex justify-content-center mt-2 ms">
        <Button
          className="video-process-btn"
          size="lg"
          color="outline-primary"
          onClick={onConfirm}
          style={{ marginRight: "26px" }}
        >
          Discard
        </Button>
        <Button
          className="video-process-btn"
          size="lg"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          Save as draft {loading && <Spinner size="sm" />}
        </Button>
      </div>
    </Modal>
  );
};

export default ReloadConfirmationModal;
